import { EpostbackParams } from 'entities/Postback';
import { i18n } from 'i18n';

export const POSTBACK_PARAMS = () => ({
	[EpostbackParams.OFFER_ID]: i18n.t('ID партнерской программы'),
	[EpostbackParams.OFFER_NAME]: i18n.t('Название партнерской программы	'),
	[EpostbackParams.SOURCE_ID]: i18n.t('ID площадки'),
	[EpostbackParams.SOURCE_NAME]: i18n.t('Название площадки'),
	[EpostbackParams.ORDER_ID]: i18n.t('ID заявки'),
	[EpostbackParams.STATUS]: i18n.t('Статус'),
	[EpostbackParams.TITLE]: i18n.t('Название'),
	[EpostbackParams.SUBID_1]: 'SubID 1',
	[EpostbackParams.SUBID_2]: 'SubID 2',
	[EpostbackParams.SUBID_3]: 'SubID 3',
	[EpostbackParams.ACTIONS_TIME]: i18n.t('Время действия'),
	[EpostbackParams.AMOUNT]: i18n.t('Сумма'),
	[EpostbackParams.CLICK_TIME]: i18n.t('Время клика'),
	[EpostbackParams.COUNTRY_CODE]: i18n.t('Код страны'),
	[EpostbackParams.CURRENCY]: i18n.t('Валюта'),
	[EpostbackParams.ERID]: i18n.t('ЕРИД'),
	[EpostbackParams.USER_AGENT]: i18n.t('User agent'),
	[EpostbackParams.USER_REFERER]: i18n.t('User referer'),
	[EpostbackParams.UUID]: i18n.t('Идентификатор'),
	[EpostbackParams.RATE_ID]: i18n.t('ID тарифа'),
});
